import { Component, Input } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';

import { ISection } from 'phase/section/section';

import { SidebarPlanModule } from '../../../coaching-plan.models';

@Component({
	selector: 'spr-section-module',
	templateUrl: './section-module.component.html',
	host: {
		class: 'flex items-start space-x-3 pointer-events-none',
	},
})
export class SectionModuleComponent {
	@Input() public section: ISection;

	@Input() public module: SidebarPlanModule;

	public editingModule: SidebarPlanModule;

	public onSettingsClick(
		e: MouseEvent,
		module: SidebarPlanModule,
		panel: OverlayPanel
	) {
		this.editingModule = module;
		panel.toggle(e);
	}
}
